import styled from 'styled-components';

const Label = styled.label`
  font-weight: bold;
  display: block;
  margin-top: 10px;
  margin-bottom: 10px;
`;

export default Label;
